import { render, staticRenderFns } from "./ManageDownloads.vue?vue&type=template&id=0a4751f0"
import script from "./ManageDownloads.vue?vue&type=script&lang=js"
export * from "./ManageDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports